import React, { FunctionComponent } from "react"
import Button, { ButtonProps } from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"

import Conditional from "../components/conditional"

interface SubmitButtonProps extends ButtonProps {
    isSubmitting: boolean
    isInvalid?: boolean
    className?: string
}

export const SubmitButton: FunctionComponent<SubmitButtonProps> = ({
    children,
    isSubmitting,
    isInvalid,
    ...props
}) => {
    return (
        <Button {...props} type="submit" disabled={isSubmitting || isInvalid}>
            {children}
            <Conditional predicate={isSubmitting}>
                <Spinner
                    animation="border"
                    role="status"
                    size="sm"
                    style={{ marginLeft: "1ch" }}
                />
            </Conditional>
        </Button>
    )
}
